import { Alert, Snackbar } from "@mui/material";

interface InfoSnackbarProps {
  open: boolean;
  handleClose: () => void;
  message: string;
}

const InfoSnackbar = ({ open, handleClose, message }: InfoSnackbarProps) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={open}
      autoHideDuration={10000}
      onClose={handleClose}
      style={{
        paddingTop: "calc(env(safe-area-inset-top) + 120px)",
      }}
    >
      <Alert onClose={handleClose} severity="info" elevation={8}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default InfoSnackbar;
